<template>
  <div id="app" class="font-yekanBakh">
    <!--    TODO: change these themes.-->
    <Payment v-if="+activeTheme === 1 && activeTheme" />
    <PaymentNewVersion v-else-if="+activeTheme !== 1 && activeTheme" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import "./assets/css/globalCss.css";
import PaymentNewVersion from "@/components/Payment/PaymentNewVersion";
import Payment from "@/components/Payment/Payment";
import alertHelper from "@/helper/AlertHelper";
export default {
  name: "App",
  components: {
    Payment,
    PaymentNewVersion,
  },
  data() {
    return {
      activeTheme: null,
      sitesApiRes: null,
    };
  },
  computed: {
    ...mapGetters([
      "getVersion",
      "getGlobalApiRequestPending",
      "getIsCompName",
      "getGatewayPendingFlag",
      "getSiteId",
      "getSiteTheme",
    ]),
  },
  methods: {
    ...mapMutations([
      "setSiteId",
      "setGatewayPendingFlag",
      "setSitesApiResult",
      "setSiteTheme",
      "setMobileLayout",
      "setSmallDesktopMonitor",
    ]),
    addBodyClass(className) {
      document.body.classList.add(className);
    },
    setBodyClass() {
      if (+this.getSiteTheme === 1) {
        this.addBodyClass("main-background");
      } else this.addBodyClass("new-main-background");
    },
    handleResize() {
      this.setMobileLayout(window.innerWidth < 1024);
      this.setSmallDesktopMonitor(window.innerWidth < 1500);
    },
    getSitesApi() {
      this.setGatewayPendingFlag(true);
      this.$http.get(`sites`).then(
        (result) => {
          this.sitesApiRes = result.body;
          this.setSitesApiResult(result.body);
          this.$nextTick(() => {
            this.setSiteId(result.data.data.id);
            const siteTheme = result.data.data.settings.theme;
            this.setSiteTheme(siteTheme);
            this.activeTheme = siteTheme;
            this.setBodyClass();
          });

          //we don't change the flag, cause we want to change it in the child component
          // this.setGatewayPendingFlag(false);
        },
        (error) => {
          this.setGatewayPendingFlag(false);
          if (error.status === 403) alertHelper.systemErrorAlert();
          else alertHelper.apiErrorAlert("", error.body.message);
        }
      );
    },
  },
  created() {
    let urlPath = window.location.hostname;
    if (urlPath === "atasn88.xyz") this.$store.state.version = "v2";
    else this.$store.state.version = "v1";
    const queryId = this.$route.query.id;
    if (!queryId) {
      alertHelper.transactionNotValidAlert();
      return;
    }
    this.getSitesApi();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    // Remove event listener to prevent memory leaks
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style>
#app {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media only screen and (max-height: 650px) and (min-width: 992px) {
  #app {
    display: block;
  }
}
@media only screen and (max-width: 992px) {
  #app {
    margin-top: 1em;
    align-items: start;
  }
}
body {
  /*margin-top: 4% !important;*/
  padding-right: 0 !important;
  overflow-x: hidden;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  height: 99vh;
}
.main-background {
  background-color: var(--main-background) !important;
}
.new-main-background {
  background-color: var(--new-version-main-background) !important;
}
@media screen and (max-height: 600px) and (min-width: 1100px) {
  /* making the page scroll when on desktop but height is less than 600 */
  /* also giving padding-top to make the top container not stuck to the top */
  .new-main-background {
    overflow-y: scroll;
    padding-top: 10vh !important;
  }
  @media screen and (max-height: 450px) {
    .new-main-background {
      overflow-y: scroll;
      padding-top: 30vh !important;
    }
  }
}
body::-webkit-scrollbar {
  display: none;
}

.alertTitleClass {
  color: red !important;
  font-weight: bold !important;
}

/*CustomBootstrapClasses*/
.shetab-add-to-card-modal-content {
  border-radius: 28px !important;
  -webkit-border-radius: 28px !important;
  -moz-border-radius: 28px !important;
  background: #eaeaea !important;
}
.carousel-indicators .active {
  width: 25px;
  height: 6px;
  background-color: #bcdcfc;
}
.carousel-indicators {
  margin-top: 0.5em;
  position: initial !important;
}
.carousel-indicators li {
  border: 1px solid var(--title-text-color);
  border-radius: 15px;
  margin-inline: 1px;
  width: 25px;
  height: 6px;
}
.form-control {
  border-radius: 5px !important;
  background-color: #dedfe273 !important;
  border: 1px solid #cbd8e3 !important;
  box-shadow: 0px 0px 15px 3px white !important;
}
.new-form-control {
  display: block;
  font-size: 0.85rem !important;
  padding-top: 0.3em;
  padding-bottom: 0.3em;
  width: 100%;
  color: #212529;
  background-clip: padding-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
  border-radius: 7px !important;
  background: var(--input-background);
  border: none !important;
}

::placeholder {
  font-size: 0.7rem !important;
}

input {
  font-size: 0.7rem !important;
  text-align: center;
}
</style>
